<template>
  <v-card
    outlined
    elevation="1"
    :loading="loading"
    :disabled="orderrItem == null"
  >
    <v-img
      class="white--text align-end"
      :aspect-ratio="mobConfig.productImageRatio"
      gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.2)"
      :src="productImage"
    >
    </v-img>
    <v-card-title>
      {{ product.title }}
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row align="start">
          <v-col>
            <v-select
              :label="$t('Velikost')"
              :disabled="orderrItem == null"
              :items="sizes"
              return-object
              v-model="selectedSize"
              item-text="size"
            ></v-select>
          </v-col>

          <v-col v-if="selectArticlesVisible">
            <v-select
              label="Model"
              :disabled="selectedSize == null"
              :items="availableArticles"
              v-model="selectedArticle"
              item-text="title"
              return-object
              @change="selectedArticleChanged"
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="loading">
          <v-col cols="12"> </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="alertLoadingVisible"
              border="left"
              color="blue"
              outlined
              icon="mdi-refresh"
            >
              Dohledáváme aktuálně dostupné velikosti a modely...
            </v-alert>
            <v-alert v-if="alertNoItemsAvailable" border="left" type="warning">
              Je nám líto, ale ve vybraném termínu jsou již všechny kusy
              rezervované.
            </v-alert>
            <v-alert
              v-if="alertChooseSizeVisible"
              border="left"
              type="warning"
              colored-border
            >
              Vyberte velikost, která vám bude nejvíce vyhovovat.
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
      <v-card-subtitle
        ><span v-html="product.description"></span
      ></v-card-subtitle>
    </v-card-text>
  </v-card>
</template>

<script>
import APIAdapter from "../store/APIAdapter";

export default {
  name: "RentOrderrItem",

  components: {},

  props: {
    product: {
      type: Object,
      required: true,
    },

    orderrItemGroup: {
      type: Object,
      required: true,
    },

    orderrItem: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      sizes: [],
      selectedSize: null,
      availableArticles: [],
      selectedArticle: null,
      loading: false,
    };
  },

  computed: {
    productImage: function () {
      if (
        this.product == undefined ||
        this.product == null ||
        this.product.images == undefined ||
        this.product.images.length == 0
      ) {
        return null;
      } else {
        return this.product.images[0];
      }
    },
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    selectArticlesVisible() {
      return this.product.rentAvailabilityMode == "INDIVIDUAL";
    },

    selectSizeColumns() {
      return this.selectArticlesVisible ? 6 : 12;
    },

    alertLoadingVisible() {
      return this.loading;
    },

    alertChooseSizeVisible() {
      return (
        !this.loading && this.sizes.length > 0 && this.selectedSize == null
      );
    },

    alertNoItemsAvailable() {
      return this.orderrItem != null && !this.loading && this.sizes.length == 0;
    },
  },

  watch: {
    selectedSize: function (val) {
      this.selectedArticleChanged();

      if (val != null) {
        this.availableArticles = [];
        this.loadRentArticlesBySize(val);
      }
    },

    orderrItem: function (val, oldVal) {
      console.log("ZMENA OI" + this.product.title);
      console.log(oldVal);
      console.log(val);
      if (oldVal == null && val != null) {
        // pro jistotu reset jeste jednou
        this.selectedSize = null;
        this.selectedArticle = null;
        this.availableArticles = [];

        this.loadRentSizeAvailability();
      } else if (oldVal != null && val == null) {
        this.selectedSize = null;
        this.selectedArticle = null;
        this.availableArticles = [];
      }
    },
  },

  methods: {
    selectedArticleChanged() {
      let oi = {
        ...this.orderrItem,
      };
      oi.article = this.selectedArticle;
      this.$emit("change", oi);
    },

    async loadRentSizeAvailability() {
      console.log("loadRentSizeAvailability");

      if (this.orderrItem == null) {
        return;
      }

      this.loading = true;

      console.log(this.orderrItemGroup);

      let resultset;
      try {
        resultset = await APIAdapter.loadRentSizeAvailability(
          this.$store.state.appInstance,
          this.$store.state.mobConfig.mobVersion,
          this.$store.state.pointSell.id,
          this.product.id,
          this.orderrItemGroup.dateStart,
          this.orderrItemGroup.dateEnd
        );
        console.log(resultset);
        this.sizes = resultset;
        if (
          this.sizes.length >= 1 &&
          this.$store.state.rentSelectSizeAutomatic
        ) {
          this.selectedSize = this.sizes[0];
        }
        this.loading = false;
      } catch (error) {
        console.error(error);

        console.log(
          "Vyhledani dostupnych velikosti trva dele, nez obvykle. Vydrzte prosim jeste chvilku."
        );
        // druhe volani
        try {
          resultset = await APIAdapter.loadRentSizeAvailability(
            this.$store.state.appInstance,
            this.$store.state.mobConfig.mobVersion,
            this.$store.state.pointSell.id,
            this.orderrItem.product.id,
            this.orderrItemGroup.dateStart,
            this.orderrItemGroup.dateEnd
          );
          console.log(resultset);
          this.sizes = resultset;
          this.loading = false;
        } catch (error) {
          console.error(error);
          this.loading = false;
        }
      }
    },

    async loadRentArticlesBySize(selectedSize) {
      this.availableArticles = null;
      this.selectedArticle = null;
      this.loading = true;
      try {
        this.availableArticles = await APIAdapter.loadRentArticlesBySize(
          this.$store.state.appInstance,
          this.$store.state.mobConfig.mobVersion,
          this.$store.state.pointSell.id,
          this.orderrItem.product.id,
          this.orderrItemGroup.dateStart,
          this.orderrItemGroup.dateEnd,
          selectedSize
        );
        if (this.availableArticles.length >= 1) {
          this.selectedArticle = this.availableArticles[0];
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
      this.selectedArticleChanged();
    },
  },

  async mounted() {
    console.log("mounted");
    // nacti dostupne velikosti
    this.loadRentSizeAvailability();
  },
};
</script>
